module.exports = __webpack_public_path__ + "static/media/diamond.c16e7ffc.svg";